import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CustomOverlay } from '@state/account/account.interfaces';

export const DEFAULT_OVERLAY_GRID_SIZE = {
  rows: 16,
  columns: 30,
};

@Injectable({
  providedIn: 'root'
})
export class GridOverlayService {

  store = inject(Store);

  generateDefaultPaths(): CustomOverlay['paths'] {
    return this.generateGrid(DEFAULT_OVERLAY_GRID_SIZE.rows, DEFAULT_OVERLAY_GRID_SIZE.columns);
  }

  // Generates a set of overlay paths for a regular grid with a given number of `rows` and `columns`
  generateGrid(rows: number|null|undefined, columns: number|null|undefined): number[][][] {
    if (rows == null || columns == null) return  [];

    const paths = [];
    for (let i = 0; i <= rows; i++) {
      const fraction = i / rows;
      paths.push([[0, fraction], [1, fraction]]);
    }

    for (let i = 0; i <= columns; i++) {
      const fraction = i / columns;
      paths.push([[fraction, 0], [fraction, 1]]);
    }
    return paths;
  }

  parseGrid(grid: number[][][]): {rows: number, columns: number} {
    let rows = 0;
    let columns = 0;

    grid.forEach(([start, end]) => {
      if (start[0] === 0 && end[0] === 1) { // If it crosses the grid horizontally then it is a row
        rows++;
      } else {
        columns++;
      }
    });
    return { rows: rows - 1, columns: columns - 1 };
  }

  percentToHex(p: number): string {
    return `0${Math.round((255 / 100) * p).toString(16)}`.slice(-2).toUpperCase();
  }

  hexToPercent(h: string): number {
    return Math.round(parseInt(h, 16) / 2.55);
  }

}
